(function () {
    'use strict';
    var m = angular.module('common');
    m.factory('suspiciousReportParams', ["modals", "emailDao", "$q", "modulesDao", "entityTypes", "fileDao", function (modals, emailDao, $q, modulesDao, entityTypes, fileDao) {
        var entityBrandConfig = {
            'office365_emails_email': {
                subject: 'Subject',
                nick: 'fromName',
                email: 'fromEmail'
            },
            'google_mail_email': {
                subject: 'subject',
                nick: 'fromName',
                email: 'from'
            }
        };
        return {
            show: function (title, entityType, entityId, args) {
                var entitySaas = entityTypes.toSaas(entityType) || args.saas || args.objectTypesData && args.objectTypesData.entities[entityType].saas;
                var localEntity = entityTypes.toLocal(entityType);
                var getEntityInfo;
                if (args.secTypes) {
                    getEntityInfo = $q.when({ sec_type_connected: secTypes });
                } else {
                    if (localEntity === 'file' || localEntity === 'email') {
                        getEntityInfo = $q.when();
                    } else {
                        if (entitySaas) {
                            getEntityInfo = modulesDao.entityInfoRaw(entitySaas, entityType);
                        } else {
                            getEntityInfo = $q.when();
                        }
                    }
                }
                return getEntityInfo.then(function (data) {
                    var secTypes = data && data.sec_type_connected || [];
                    var variants = [
                        {
                            id: 'clean',
                            label: 'Clean'
                        },
                        {
                            id: 'unknown',
                            label: 'Unknown'
                        }
                    ];
                    if (localEntity === 'email' || _(secTypes).contains('ap')) {
                        variants.unshift({
                            id: 'spam',
                            label: 'Spam'
                        });
                        variants.unshift({
                            id: 'marketing',
                            label: 'Marketing'
                        });
                        variants.unshift({
                            id: 'phishing',
                            label: 'Phishing'
                        });
                    }
                    if (localEntity === 'file' || _(secTypes).contains('av')) {
                        variants.unshift({
                            id: 'malicious',
                            label: 'Malicious'
                        });
                    }
                    var params = [{
                            id: 'status',
                            type: 'selector',
                            label: 'Report as ',
                            variants: variants,
                            data: variants[0].id
                        }];
                    if (entityType && entityId && (localEntity === 'email' || _(secTypes).contains('ap'))) {
                        var resolveTimeout = $q.defer();
                        params.push({
                            type: 'message',
                            message: 'Searching for similar emails...',
                            emptyLabel: true,
                            resolveTimeout: resolveTimeout,
                            resolve: function () {
                                return $q.all([
                                    emailDao.similarEmailCount(entityType, entityId, 'subject_sender', resolveTimeout.promise),
                                    emailDao.similarEmailCount(entityType, entityId, 'subject', resolveTimeout.promise)
                                ]).then(function (responses) {
                                    var counts = _([
                                        {
                                            'type': 'subject_sender',
                                            label: 'emails with same Subject and Sender',
                                            count: responses[0].data.count
                                        },
                                        {
                                            'type': 'subject',
                                            label: 'emails with same Subject',
                                            count: responses[1].data.count
                                        }
                                    ]).filter(function (data) {
                                        return data.count;
                                    });
                                    if (!counts.length) {
                                        return {
                                            type: 'message',
                                            message: 'No similar emails found',
                                            emptyLabel: true
                                        };
                                    }
                                    var options = _(counts).map(function (item) {
                                        return {
                                            value: item.type,
                                            label: 'Report also ' + item.label + ' (' + item.count + ' emails)'
                                        };
                                    });
                                    options.unshift({ label: 'Report only this e-mail' });
                                    return {
                                        id: 'similar_mode',
                                        type: 'radio-group',
                                        emptyLabel: true,
                                        buttons: options
                                    };
                                });
                            }
                        });
                    }
                    if (args.entityData && entityBrandConfig[entityType]) {
                        var matched;
                        var brand_name_by_from_domain_values = '';
                        if (args.entityData[entityBrandConfig[entityType].email]) {
                            matched = args.entityData[entityBrandConfig[entityType].email].match(/@([^ ,;]+)/);
                            if (matched && matched.length > 1) {
                            }
                            brand_name_by_from_domain_values = [matched[1]];
                        }
                        var brand_name_by_from_nickname_values = '';
                        if (args.entityData[entityBrandConfig[entityType].nick]) {
                            brand_name_by_from_nickname_values = args.entityData[entityBrandConfig[entityType].nick].split(/[\s,;\.\?\!#$@\(\)+\-\=\[\]\\\/<>\^&%|'"`~]+/);
                            if (brand_name_by_from_nickname_values.length > 1) {
                                brand_name_by_from_nickname_values.unshift(args.entityData[entityBrandConfig[entityType].nick]);
                            }
                        }
                        var brand_name_by_subject_values;
                        var subject = args.entityData[entityBrandConfig[entityType].subject];
                        if (subject) {
                            brand_name_by_subject_values = subject.split(/[\s,;\.\?\!#$@\(\)+\-\=\[\]\\\/<>\^&%|'"`~]+/);
                            var re = /\"([^\"]+)\"/g;
                            while (!_(matched = re.exec(subject)).isNull()) {
                                if (matched.length > 1) {
                                    brand_name_by_subject_values.push(matched[1]);
                                }
                            }
                            re = /\'([^\"]+)\'/g;
                            while (!_(matched = re.exec(subject)).isNull()) {
                                if (matched.length > 1) {
                                    brand_name_by_subject_values.push(matched[1]);
                                }
                            }
                            brand_name_by_subject_values = _(brand_name_by_subject_values).compact();
                        }
                        params.push({
                            id: 'brand_name_is',
                            type: 'boolean',
                            rightLabel: 'Is brand related',
                            emptyLabel: true
                        });
                        params.push({
                            id: 'brand_name_global',
                            type: 'string',
                            label: 'Global brand name',
                            validation: { required: true },
                            enabled: {
                                param: 'brand_name_is',
                                equal: true
                            }
                        });
                        params.push({
                            id: 'brand_name_by_from_domain_is',
                            type: 'boolean',
                            rightLabel: 'Brand name in domain',
                            emptyLabel: true,
                            enabled: {
                                param: 'brand_name_is',
                                equal: true
                            }
                        });
                        params.push({
                            id: 'brand_name_by_from_domain_values',
                            type: 'list',
                            label: 'Brands from domain',
                            enabled: {
                                param: 'brand_name_by_from_domain_is',
                                equal: true
                            },
                            data: brand_name_by_from_domain_values
                        });
                        params.push({
                            id: 'brand_name_by_from_nickname_is',
                            type: 'boolean',
                            rightLabel: 'Brand name in nickname',
                            emptyLabel: true,
                            enabled: {
                                param: 'brand_name_is',
                                equal: true
                            }
                        });
                        params.push({
                            id: 'brand_name_by_from_nickname_values',
                            type: 'list',
                            label: 'Brands from nickname',
                            enabled: {
                                param: 'brand_name_by_from_nickname_is',
                                equal: true
                            },
                            data: brand_name_by_from_nickname_values
                        });
                        params.push({
                            id: 'brand_name_by_subject_is',
                            type: 'boolean',
                            rightLabel: 'Brand name in subject',
                            emptyLabel: true,
                            enabled: {
                                param: 'brand_name_is',
                                equal: true
                            }
                        });
                        params.push({
                            id: 'brand_name_by_subject_values',
                            type: 'list',
                            label: 'Brands from subject',
                            enabled: {
                                param: 'brand_name_by_subject_is',
                                equal: true
                            },
                            data: brand_name_by_subject_values
                        });
                    }
                    if (entityType && entityId) {
                        var linkResolveTimeout = $q.defer();
                        params.push({
                            id: 'add_link_info',
                            type: 'boolean',
                            rightLabel: 'Add link info',
                            emptyLabel: true,
                            enabled: {
                                param: 'status',
                                in: [
                                    'phishing',
                                    'spam',
                                    'marketing'
                                ]
                            }
                        }, {
                            type: 'message',
                            message: 'Searching for links in the email',
                            emptyLabel: true,
                            linkResolveTimeout: linkResolveTimeout,
                            enabled: {
                                param: 'add_link_info',
                                equal: true
                            },
                            resolve: function () {
                                return fileDao.avananApDebugLinks(entityId, entityType).timeout(linkResolveTimeout.promise).then(function (response) {
                                    return {
                                        id: 'links',
                                        label: 'Links',
                                        type: 'list',
                                        enabled: {
                                            param: 'add_link_info',
                                            equal: true
                                        },
                                        settings: {
                                            multiple: true,
                                            allowCreate: true,
                                            allowClear: true
                                        },
                                        variants: _(response.data.rows).map(function (row) {
                                            return {
                                                id: row.link,
                                                label: row.link
                                            };
                                        })
                                    };
                                });
                            }
                        });
                    }
                    return modals.params([{
                            lastPage: true,
                            params: params,
                            okButton: 'Send Report'
                        }], title);
                });
            }
        };
    }]);
}());